import { useEffect, useState } from 'react'

export function useSizeObserver(): [
  (element: HTMLDivElement) => void,
  number,
  number,
] {
  const [height, setHeight] = useState<number>(0)
  const [width, setWidth] = useState<number>(0)
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const updateSizes = (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        if (ref && entry.target === ref) {
          setHeight(entry.contentRect.height)
          setWidth(entry.contentRect.width)
        }
      }
    }

    const resizeObserver = new ResizeObserver(updateSizes)

    if (ref) {
      resizeObserver.observe(ref)
    }

    return () => {
      if (ref) {
        resizeObserver.unobserve(ref)
      }
    }
  }, [ref])

  return [setRef, width, height]
}
